export default "__VITE_ASSET__0XlJzSey__"